var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V12.01M14.828 9.17202C15.5779 9.92213 15.9991 10.9394 15.9991 12C15.9991 13.0607 15.5779 14.0779 14.828 14.828M17.657 6.34302C18.3999 7.08589 18.9892 7.96782 19.3913 8.93846C19.7933 9.90909 20.0003 10.9494 20.0003 12C20.0003 13.0506 19.7933 14.0909 19.3913 15.0616C18.9892 16.0322 18.3999 16.9141 17.657 17.657M9.168 14.828C8.41811 14.0779 7.99685 13.0607 7.99685 12C7.99685 10.9394 8.41811 9.92213 9.168 9.17202M6.337 17.657C5.59408 16.9141 5.00477 16.0322 4.60271 15.0616C4.20065 14.0909 3.99371 13.0506 3.99371 12C3.99371 10.9494 4.20065 9.90909 4.60271 8.93846C5.00477 7.96782 5.59408 7.08589 6.337 6.34302",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/Network.c9df157c4ba40c79baed4c0526a28e26.svg";
export { ForwardRef as ReactComponent };